import type { FunctionComponent } from 'react';

import { L12nText } from '../../text';

import styles from './HistoryMessage.module.css';

export interface HistoryDayProps {
  title: string;
  message: string;
}

export const HistoryMessage: FunctionComponent<HistoryDayProps> = ({ title, message }) => {
  return (
    <>
      <div className={styles.title}>
        <L12nText tk={title} />
      </div>
      <div className={styles.message}>
        <L12nText tk={message} />
      </div>
    </>
  );
};
